import {Loader} from "../../../components/shared/index";
import authService from "../../../services/authService";
import ReviewTabs from "./ReviewTabs/ReviewTabs";
import styles from './productdetails.module.css'

const ProductTabs = ({ productData, isPending, isFetching }) => {
 let user = null;

  try {
    user = authService.getCurrentUser();
  } catch (err) {
    user = null;
  }  if (isPending || isFetching) {
    return (
      <div className={styles.tabsSkeleton}>
        <Loader title="Loading product details..." />
      </div>
    );
  }
  if (!productData) return null;

  return (
    <ReviewTabs
      productId = {productData?.id}
      productDescription={productData?.long_description}
      loggedInUserId={user?.id || null}
    />
  );
};

export default ProductTabs;